
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1s55x_n9frk_145",
  "label": "awsui_label_1s55x_n9frk_149",
  "label-top": "awsui_label-top_1s55x_n9frk_163",
  "stud": "awsui_stud_1s55x_n9frk_168"
};
  